(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js');

'use strict';

svs.numbergames.mybets_common_wager.models.Wager = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    wagerId: undefined,
    productName: '',
    productId: '',
    betAmount: undefined,
    channel: '',
    bagType: 0,
    packageName: undefined,
    description: '',
    extraDescription: undefined,
    descriptionItems: undefined,
    isSystemWager: false,
    isPackageWager: false,
    isCompositePackage: false,
    isSingleWager: false,
    isUserBoards: false,
    isSubscription: false,
    isFraction: false,
    fractionHolderFractionCount: 0,
    fractionHolderAmount: undefined,
    customerFractionCount: 0,
    isSyndicate: false,
    syndicateId: undefined,
    syndicateName: undefined,
    syndicateBettor: undefined,
    syndicateParticipantCount: undefined,
    syndicateParticipatingMembers: undefined,
    syndicateMembers: undefined,
    syndicateCurrentMember: undefined,
    syndicateIsPermissionBlocked: false,
    isCancellable: true,
    currentDrawNumber: '',
    currentAddonDrawNumber: undefined,
    currentDrawCount: 1,
    isCancelClosed: false,
    isPreProlonged: false,
    cancelCloseTime: '',
    isRegClosed: false,
    regCloseTime: '',
    firstDrawNumber: undefined,
    completedDrawCount: 0,
    totalDrawCount: 1,
    hasMultipleDraws: false,
    regWagerTime: '',
    lastDrawDate: '',
    isExamined: false,
    winAmount: 0,
    completedOn: '',
    bet: undefined,
    jokerBet: undefined,
    rowCount: 0,
    hasLotto2: false,
    hasJoker: false,
    lotto1Bet: undefined,
    lotto2Bet: undefined
  },
  url() {
    return "".concat(svs.core.jupiter.url(), "/player/1/wagers/").concat(this.get('wagerId'));
  },
  parseRawResponse(resp) {
    return resp.wager;
  },
  initialize() {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager initialize', this.attributes);
  },
  parse(attrs) {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager parse', attrs);
    attrs = svs.numbergames.mybets_core_wager.parsers.parseWager(attrs);
    if (attrs.bet) {
      attrs.bet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.bet, {
        parse: true
      });
    }
    if (attrs.jokerBet) {
      attrs.jokerBet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.jokerBet, {
        parse: true
      });
    }
    return attrs;
  }
});

 })(window);